import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../../lib/content";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="relative py-24 md:py-36 border-t border-white/5" data-testid="faq-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-4">
            <div className="tag-glass"><span className="dot" /> Questions</div>
            <h2 className="font-display text-white text-4xl md:text-6xl leading-[1.02] tracking-tight mt-6 sticky top-24">
              Everything <br /><span className="italic-accent text-grad-crimson">worth asking</span>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8">
            <ul className="border-t border-white/10">
              {FAQS.map((f, i) => {
                const open = openIdx === i;
                return (
                  <li key={i} className="border-b border-white/10">
                    <button
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left group"
                      data-testid={`faq-item-${i}`}
                      aria-expanded={open}
                    >
                      <div className="flex items-start gap-6">
                        <span className="font-mono text-white/40 text-sm mt-1">{String(i + 1).padStart(2, "0")}</span>
                        <span className="font-display text-white text-xl md:text-2xl tracking-tight max-w-[560px] leading-snug">{f.q}</span>
                      </div>
                      <span className="mt-1 shrink-0 w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:border-[#e63946] transition-colors">
                        {open ? <Minus className="w-4 h-4 text-white" /> : <Plus className="w-4 h-4 text-white" />}
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {open && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                          className="overflow-hidden"
                        >
                          <div className="pb-8 md:pb-10 pl-0 md:pl-16 text-white/75 text-lg leading-relaxed max-w-2xl">
                            {f.a}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
